"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setUserTheme_1 = require("../services/setUserTheme");
var getTheme_1 = require("owa-theme/lib/utils/getTheme");
var loadTheme_1 = require("owa-theme/lib/actions/loadTheme");
var owa_options_core_1 = require("owa-options-core");
var owa_analytics_1 = require("owa-analytics");
var onCommitThemeChange_1 = require("owa-options-actions/lib/onCommitThemeChange");
var OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingTheme';
function commitThemeChange(themeId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var newTheme;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (themeId) {
                        loadTheme_1.default(themeId);
                    }
                    newTheme = getTheme_1.default();
                    onCommitThemeChange_1.default(newTheme);
                    owa_options_core_1.updateUserOptions({ ThemeStorageId: newTheme });
                    return [4 /*yield*/, setUserTheme_1.default(newTheme)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = commitThemeChange;
function commitQuickThemeChange(themeId) {
    owa_analytics_1.logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [
        themeId /* What theme the user chose */,
        getTheme_1.default() /* What theme the user is switching away from */,
    ]);
    commitThemeChange(themeId);
}
exports.commitQuickThemeChange = commitQuickThemeChange;
//# sourceMappingURL=commitThemeChange.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/orchestration/commitThemeChange.js
// module id = 3728
// module chunks = 2